'use client'

import { useEffect, useState } from 'react'

/**
 * Which nav link is active: the topmost section whose heading area sits in the band just under
 * the sticky bar. The bottom margin keeps a tall section from winning the moment its last pixel
 * enters the viewport.
 */
export function useScrollSpy(ids: readonly string[]): string {
  const [active, setActive] = useState('')
  const key = ids.join(',')

  useEffect(() => {
    const elements = key
      .split(',')
      .map((id) => document.getElementById(id))
      .filter((element): element is HTMLElement => element !== null)
    if (elements.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        const topmost = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0]
        if (topmost) setActive(topmost.target.id)
      },
      { rootMargin: '-80px 0px -65% 0px' }
    )
    for (const element of elements) observer.observe(element)
    return () => observer.disconnect()
  }, [key])

  return active
}
